import { Form, FormProps, Input, Radio } from "antd";
import { useEffect } from "react";
import {
  createCategoryAsync,
  getAllCategoryAsync,
  updateCategoryAsync,
} from "../../../store/features/category/categoryApi";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { ModalType } from "../../../types";
import { CreateCategoryData } from "../../../types/category/category";
import FormModal from "../../ui/FormModal";

type Props = {
  open: ModalType;
  handleClose: () => void;
};

export default function ManageContentCategory({ open, handleClose }: Props) {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { manageLoading } = useAppSelector((state) => state.category);

  const contentCategoryData = open?.data as CreateCategoryData;
  const onFinish: FormProps<any>["onFinish"] = (values) => {
    if (open?.type === "EDIT" && contentCategoryData?._id) {
      dispatch(
        updateCategoryAsync({
          data: values,
          others: {
            reRender: handleClose,
            id: open?.data?._id,
          },
        })
      );
    } else {
      dispatch(
        createCategoryAsync({
          data: values,
          others: {
            reRender: handleClose,
          },
        })
      );
    }
  };

  // add value in modal for view and edit
  useEffect(() => {
    if (
      (open?.type === "EDIT" || open?.type === "VIEW") &&
      manageLoading === false
    ) {
      form.setFieldsValue({
        categoryStatus: contentCategoryData?.categoryStatus,
        categoryName: contentCategoryData?.categoryName,
        categoryType: contentCategoryData?.categoryType,
      });
    }
  }, [
    contentCategoryData?.categoryName,
    contentCategoryData?.categoryStatus,
    contentCategoryData?.categoryType,
    form,
    manageLoading,
    open?.type,
  ]);

  //dispatch
  useEffect(() => {
    dispatch(
      getAllCategoryAsync({
        params: {
          skip: 0,
          limit: 0,
          categoryType: "Publication",
        },
      })
    );
  }, [dispatch]);

  return (
    <FormModal
      disabled={false}
      open={open?.open}
      //   showDraft={true}
      isUpdate={open?.type === "EDIT"}
      //   hideBtn={true}
      title={`${
        open?.type === "EDIT"
          ? "Update"
          : open?.type === "VIEW"
          ? "View"
          : "Add"
      } Category`}
      onFinish={onFinish}
      hideBtn={open?.type === "VIEW"}  // Added this line to hide button in VIEW mode
      handleClose={handleClose}
      buttonText={open?.type === "EDIT" ? "Update" : "Add"}
      formProps={{
        form,
      }}
    >
      <Form.Item
        name="categoryType"
        label="Category Type"
        initialValue="Publication"
      >
        <Input defaultValue={"Publication"} size="large" disabled />
      </Form.Item>

      <Form.Item
        name="categoryName"
        label="Category Name"
        rules={[
          {
            required: true,
            message: "Please enter category name",
          },
        ]}
      >
        <Input
          size="large"
          placeholder="Enter category name"
          disabled={open?.type === "VIEW"}
        />
      </Form.Item>

      <Form.Item
        name="categoryStatus"
        label="Category Status"
        rules={[
          {
            required: true,
            message: "Please select category status",
          },
        ]}
      >
        <Radio.Group 
          className="custom-radio" 
          size="large"
          disabled={open?.type === "VIEW"}
        >
          {trainingMaterialStatus?.map((el, idx) => (
            <Radio
              className="text-body text-base font-medium leading-7 mr-3.5"
              value={el}
              key={idx}
            >
              {el}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
    </FormModal>
  );
}

const trainingMaterialStatus = ["Published", "Draft", "Archived"];
